
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dYN4E", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6xdDU = parcelRequire("6xdDU");


var $lsxnT = parcelRequire("lsxnT");

/* RovoAnnouncementSplashComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $1Whri = parcelRequire("1Whri");


var $hmuev = parcelRequire("hmuev");


var $1s5hv = parcelRequire("1s5hv");

var $d8SNb = parcelRequire("d8SNb");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $cO1el = parcelRequire("cO1el");


var $gNXND = parcelRequire("gNXND");


var $ZDq1z = parcelRequire("ZDq1z");


var $e0ycV = parcelRequire("e0ycV");


var $jyA9t = parcelRequire("jyA9t");

/* CreateWithRovoLogo.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");




const $94a3f55d0cc19894$var$styles = null;
const $94a3f55d0cc19894$export$440cce1dd276e44d = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip0_681_82381)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.58938 45.4461C7.06708 40.1372 10.1367 34.5994 15.4456 33.0771L34.6709 27.5644C39.9798 26.0421 45.5175 29.1117 47.0399 34.4206L52.5526 53.6459C54.0749 58.9548 51.0053 64.4925 45.6964 66.0148L26.4711 71.5276C21.1622 73.0499 15.6244 69.9802 14.1021 64.6713L8.58938 45.4461Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip1_681_82381)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: "url(#clip2_681_82381)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M40.2144 50.708C33.4587 49.5404 31.6025 49.6087 29.1025 50.3256C26.1693 51.1667 24.0193 53.1036 22.7694 57.1734L22.5635 57.8391C22.3959 58.3868 22.3765 58.5708 22.4332 58.7686C22.4899 58.9665 22.6372 59.1027 23.0701 59.2284L27.5079 60.4896C27.7457 60.5642 27.9313 60.5823 28.098 60.5345C28.298 60.4772 28.4029 60.34 28.5178 59.9859L28.8531 58.8906C29.3798 57.205 30.0807 56.5044 31.1473 56.1985C32.0806 55.9309 33.2562 55.8793 34.812 56.147L39.2747 56.8658C39.7314 56.9489 40.1363 56.7257 40.204 56.2067L40.8981 51.5825C40.9657 51.0635 40.7473 50.805 40.2144 50.708ZM20.8442 48.4469C27.6 49.6144 29.4562 49.5461 31.9561 48.8293C34.8894 47.9882 37.0394 46.0512 38.2893 41.9814L38.4952 41.3157C38.6628 40.768 38.6822 40.584 38.6255 40.3862C38.5687 40.1883 38.4215 40.0521 37.9886 39.9264L33.5507 38.6652C33.3129 38.5907 33.1273 38.5725 32.9607 38.6203C32.7607 38.6776 32.6557 38.8148 32.5408 39.1689L32.2056 40.2643C31.6789 41.9498 30.978 42.6504 29.9113 42.9563C28.978 43.2239 27.8024 43.2755 26.2467 43.0079L21.784 42.2891C21.3273 42.2059 20.9223 42.4291 20.8547 42.9481L20.1606 47.5723C20.093 48.0913 20.3114 48.3498 20.8442 48.4469Z",
        fill: "white"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("mask", {
        id: "mask0_681_82381",
        maskUnits: "userSpaceOnUse",
        x: "43",
        y: "31",
        width: "42",
        height: "41",
        className: (0, $gMc0m.default)([
            "_13aebcex"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M82.564 60.9541C83.1722 59.6758 83.6876 58.2739 84.0999 56.7586C84.5123 55.2432 84.7906 53.7279 84.9143 52.3053C85.6668 43.7802 81.3888 37.2343 73.8224 33.7913C72.5338 33.2037 71.1422 32.7089 69.6784 32.3069C68.2146 31.9048 66.6374 31.6059 65.1632 31.4616C56.8855 30.6266 49.8861 34.0902 46.2266 41.77C45.6081 43.0689 45.0823 44.4812 44.6597 46.0274C44.237 47.5737 43.9793 49.0066 43.8556 50.4291C43.1134 58.8924 47.3811 65.4383 54.9579 68.9226C56.298 69.5411 57.7411 70.0668 59.2771 70.4791C60.8131 70.8915 62.1944 71.1492 63.6067 71.3038C71.8844 72.1697 78.9044 68.6958 82.564 60.9747V60.9541Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        mask: "url(#mask0_681_82381)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M138.911 -12.6332L3.87695 -19.0249L-1.88939 102.798L133.145 109.19L138.911 -12.6332Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M98.0775 -14.5657L3.86833 -19.0293L1.99219 20.6583C13.5274 35.1933 30.3714 44.9863 50.9162 49.419C55.019 50.3055 59.2764 50.9859 63.6678 51.4394C66.0387 51.6868 68.4612 51.8724 70.9146 51.9858C77.6152 52.3053 84.0683 52.0992 90.2636 51.3879C108.592 49.2953 124.488 42.7494 136.806 32.0904L138.93 -12.638L98.1084 -14.576L98.0775 -14.5657Z",
        fill: "#FCA700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M98.0777 -14.5659C82.3263 -3.92757 71.1107 12.2877 66.1936 33.6468C64.905 39.234 64.0494 45.1717 63.6577 51.4495C63.6164 52.0887 63.5855 52.7278 63.5546 53.3772C63.2247 60.2736 63.4927 66.8092 64.3071 72.9942C65.9874 85.7561 70.0077 96.9718 76.0175 106.497L133.137 109.208L136.786 32.1109L138.91 -12.6176L98.088 -14.5556L98.0777 -14.5659Z",
        fill: "#6A9A23"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M90.2432 51.398C126.56 47.2437 153.321 25.6577 161.66 -10.9167C162.939 -16.5142 163.784 -22.4622 164.165 -28.7607C162.042 -28.9669 159.887 -29.1318 157.712 -29.2349C150.723 -29.5648 144.002 -29.3277 137.569 -28.5649C101.284 -24.2662 74.595 -2.77306 66.2039 33.6468C64.9153 39.234 64.0597 45.1717 63.668 51.4495C66.0389 51.6969 68.4614 51.8825 70.9148 51.9959C77.6153 52.3154 84.0684 52.1093 90.2638 51.398H90.2432Z",
        fill: "#AF59E1"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M52.8445 57.6143C52.7621 58.2637 52.628 58.8925 52.4219 59.5007C52.6177 58.8925 52.7621 58.2637 52.8445 57.6143Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M52.525 53.656C52.8136 54.6559 52.9373 55.6558 52.9167 56.6351C52.9373 55.6558 52.8136 54.6456 52.525 53.656Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M52.5256 53.656L48.1754 38.4922C47.4538 39.4818 46.794 40.5642 46.2271 41.7497C45.6704 42.9248 45.1962 44.2134 44.7942 45.5947C44.753 45.7391 44.7014 45.8627 44.6602 46.0071C44.2478 47.5224 43.9798 48.9862 43.8561 50.4088C43.5159 54.3054 44.2478 57.7897 45.8663 60.7585C46.6188 62.1398 47.5569 63.4078 48.6805 64.552C50.4535 63.2944 51.7524 61.511 52.4122 59.4906C52.608 58.8824 52.7523 58.2535 52.8348 57.6041C52.876 57.2845 52.8967 56.9547 52.907 56.6248C52.9276 55.6455 52.8039 54.6353 52.5152 53.6456L52.5256 53.656Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M51.0205 50.8105L77.7607 51.9032",
        stroke: "white",
        strokeWidth: "4.40172",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M64.9364 37.9766L63.8438 64.7167",
        stroke: "white",
        strokeWidth: "4.40172",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip0_681_82381"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M8.58938 45.4461C7.06708 40.1372 10.1367 34.5994 15.4456 33.0771L34.6709 27.5644C39.9798 26.0421 45.5175 29.1117 47.0399 34.4206L52.5526 53.6459C54.0749 58.9548 51.0053 64.4925 45.6964 66.0148L26.4711 71.5276C21.1622 73.0499 15.6244 69.9802 14.1021 64.6713L8.58938 45.4461Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip1_681_82381"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "30",
        height: "30",
        fill: "white",
        transform: "translate(11.8174 39.3188) rotate(-16)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: "clip2_681_82381"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "20.6319",
        height: "19.725",
        fill: "white",
        transform: "translate(17.8945 42.9404) rotate(-16)"
    }))));
};


/* RovoAnnouncementSplashRightPanel.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $cOrQJ = parcelRequire("cOrQJ");





var $gj7hi = parcelRequire("gj7hi");

var $22b89c73a10a388b$exports = {};
$22b89c73a10a388b$exports = new URL("LightModeFrame1.88b5dbfe.gif", import.meta.url).toString();


var $62b31ccdd401fa04$exports = {};
$62b31ccdd401fa04$exports = new URL("DarkModeFrame1.6ac03536.gif", import.meta.url).toString();


var $b4fc4c22696cb14c$exports = {};
$b4fc4c22696cb14c$exports = new URL("LightModeFrame2.b826bbb1.gif", import.meta.url).toString();


var $131f7d9ae32a24b5$exports = {};
$131f7d9ae32a24b5$exports = new URL("DarkModeFrame2.efe28578.gif", import.meta.url).toString();


var $9c1a9f577a620f96$exports = {};
$9c1a9f577a620f96$exports = new URL("LightModeFrame3.dbfb7a04.gif", import.meta.url).toString();


var $642fed45a819cb76$exports = {};
$642fed45a819cb76$exports = new URL("DarkModeFrame3.d087cb13.gif", import.meta.url).toString();


const $1c0a8b0f35323e7a$var$styles = {
    background: "_kqswh2mm _bfhkrwxf",
    frame: "_kqswh2mm",
    image: "_2rkolb4i"
};
const $1c0a8b0f35323e7a$var$backgroundGridAnimation = null;
const $1c0a8b0f35323e7a$var$backgroundGrid = null;
const $1c0a8b0f35323e7a$var$accentBoxUpper = null;
const $1c0a8b0f35323e7a$var$accentBoxUpperAnimationFrame1 = null;
const $1c0a8b0f35323e7a$var$accentBoxUpperFrame1 = null;
const $1c0a8b0f35323e7a$var$accentBoxUpperAnimationFrame2 = null;
const $1c0a8b0f35323e7a$var$accentBoxUpperFrame2 = null;
const $1c0a8b0f35323e7a$var$accentBoxLower = null;
const $1c0a8b0f35323e7a$var$accentBoxLowerAnimationFrame1 = null;
const $1c0a8b0f35323e7a$var$accentBoxLowerFrame1 = null;
const $1c0a8b0f35323e7a$var$accentBoxLowerAnimationFrame2 = null;
const $1c0a8b0f35323e7a$var$accentBoxLowerFrame2 = null;
const $1c0a8b0f35323e7a$var$lightModeFrameMap = [
    (0, (/*@__PURE__*/$parcel$interopDefault($22b89c73a10a388b$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b4fc4c22696cb14c$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($9c1a9f577a620f96$exports)))
];
const $1c0a8b0f35323e7a$var$darkModeFrameMap = [
    (0, (/*@__PURE__*/$parcel$interopDefault($62b31ccdd401fa04$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($131f7d9ae32a24b5$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($642fed45a819cb76$exports)))
];
const $1c0a8b0f35323e7a$var$ImageComponent = ({ frame: frame })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1c0a8b0f35323e7a$var$styles.frame
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
    ), {
        testId: `create-with-rovo-image-frame-${frame}`,
        alt: "",
        src: $1c0a8b0f35323e7a$var$lightModeFrameMap[frame],
        srcDark: $1c0a8b0f35323e7a$var$darkModeFrameMap[frame],
        width: frame === 0 ? 484 : 392,
        className: (0, $gMc0m.default)([
            $1c0a8b0f35323e7a$var$styles.image
        ])
    }));
};
const $1c0a8b0f35323e7a$export$3f65779459d87753 = ({ frame: frame })=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    (0, $42omo.useEffect)(()=>{
        // Preload images to prevent flickering, only preload images for the current color mode
        const preloadImages = async ()=>{
            const frameMap = colorMode === 'dark' ? $1c0a8b0f35323e7a$var$darkModeFrameMap : $1c0a8b0f35323e7a$var$lightModeFrameMap;
            await Promise.all([
                ...frameMap
            ].map((url)=>new Promise((resolve, reject)=>{
                    const img = new window.Image();
                    img.src = url;
                    img.onload = resolve;
                    img.onerror = reject;
                })));
        };
        preloadImages();
    }, [
        colorMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $1c0a8b0f35323e7a$var$styles.background,
        justifyContent: "center",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_y44v10vx _kqswstnw _4t3i1osq _1bsb1osq _1itk1mc5 _1lrw1d7l _ouxl1nty _tzy4sxj9"
        ])
    }), frame !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "create-with-rovo-image-accents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _154i18cf _1ltvldb6 _1bsbp2n4 _4t3i1lit _bfhk16e3",
            frame === 1 && "",
            frame === 1 && "_y44v1y1d _t9ec1csx",
            frame === 2 && "",
            frame === 2 && "_y44vxheo _t9ec13hc"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_kqswstnw _94n51j4a _1xi2ldb6 _1bsbuuw1 _4t3i7iqz _bfhk16e3",
            frame === 1 && "",
            frame === 1 && "_y44v8p30 _t9ec1e2d",
            frame === 2 && "",
            frame === 2 && "_y44v1yu7 _t9ec13tq"
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1c0a8b0f35323e7a$var$ImageComponent, {
        frame: frame
    }));
};














var $7YEWU = parcelRequire("7YEWU");


var $lOHzS = parcelRequire("lOHzS");

const $32f11c1404dd391d$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    pauseButtonLabel: {
        id: "create-with-rovo-announcement-splash.carouselControl.pauseButtonLabel",
        defaultMessage: "Pause"
    },
    resumeButtonLabel: {
        id: "create-with-rovo-announcement-splash.carouselControl.resumeButtonLabel",
        defaultMessage: "Resume"
    }
});
const $32f11c1404dd391d$export$f4f648ca4de05347 = ({ isPlaying: isPlaying, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const iconButtonLabel = isPlaying ? formatMessage($32f11c1404dd391d$export$a7357cdd1f0b0168.pauseButtonLabel) : formatMessage($32f11c1404dd391d$export$a7357cdd1f0b0168.resumeButtonLabel);
    const IconButtonIcon = isPlaying ? (0, (/*@__PURE__*/$parcel$interopDefault($7YEWU))) : (0, (/*@__PURE__*/$parcel$interopDefault($lOHzS)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "default",
        label: iconButtonLabel,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IconButtonIcon, {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            }),
        shape: "circle",
        onClick: onClick
    });
};


const $53648eaef7ca25f4$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    modalTitle: {
        id: "create-with-rovo-announcement-splash.modal.title",
        defaultMessage: "Introducing Create with Rovo"
    },
    modalSubtitle: {
        id: "create-with-rovo-announcement-splash.modal.subtitle",
        defaultMessage: "Bye-bye, blank page. Rovo can create what you need with a simple description and the power of your team's data."
    },
    modalMenuItemDescribe: {
        id: "create-with-rovo-announcement-splash.modal.menu.item.describe",
        defaultMessage: "Describe what to create, let Rovo start it"
    },
    modalMenuItemWhiteboard: {
        id: "create-with-rovo-announcement-splash.modal.menu.item.whiteboard",
        defaultMessage: "Put an idea on a page, let Rovo whiteboard it"
    },
    modalMenuItemEdit: {
        id: "create-with-rovo-announcement-splash.modal.menu.item.edit",
        defaultMessage: "Brain dump thoughts on a page, let Rovo edit it"
    },
    modalButtonText: {
        id: "create-with-rovo-announcement-splash.modal.button.text",
        defaultMessage: "Try Create with Rovo"
    },
    dismissButtonLabel: {
        id: "create-with-rovo-announcement-splash.modal.dismiss.button.label",
        defaultMessage: "Dismiss"
    }
});
const $53648eaef7ca25f4$var$styles = {
    container: "_2rko1kw7 _kqswh2mm _1bsb1osq _4t3i1osq _mkrzusvi",
    grid: "_yv0ewxkt _1tke1oh5",
    closeButton: "_kqswstnw _154ipxbi _1xi2pxbi",
    textContainer: "_18zr1jfw _4t3i1osq _ca0qoahv _n3td1jfw",
    titleContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _zulpv47k",
    menuItem: "_zulpu2gc _1yt4utpp _2rko1qi0 _1e0c1txw _4cvr1h6o _1wpz1fhb _bfhksm61 _y3gn1e5h _irr31dpa _1di6fcek",
    activeMenuItem: "_bfhk1dpa",
    ctaButtonContainer: "_ca0qutpp",
    carouselControl: "_kqswstnw _94n5pxbi _1xi2pxbi"
};
const $53648eaef7ca25f4$var$ANALYTICS_SOURCE = 'createWithRovoAnnouncementSplashModal'; // Label for analytic attribute
const $53648eaef7ca25f4$var$menuItemLabels = [
    $53648eaef7ca25f4$export$a7357cdd1f0b0168.modalMenuItemDescribe.defaultMessage,
    $53648eaef7ca25f4$export$a7357cdd1f0b0168.modalMenuItemWhiteboard.defaultMessage,
    $53648eaef7ca25f4$export$a7357cdd1f0b0168.modalMenuItemEdit.defaultMessage
];
const $53648eaef7ca25f4$export$3ceb38454e45a63d = ({ onModalShown: onModalShown })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [selectedGif, setSelectedGif] = (0, $42omo.useState)(0);
    const [isAutoRotationEnabled, setIsAutoRotationEnabled] = (0, $42omo.useState)(true);
    (0, $42omo.useEffect)(()=>{
        const intervalId = setInterval(()=>{
            if (isAutoRotationEnabled) setSelectedGif((prevSelectedGif)=>(prevSelectedGif + 1) % 3);
        }, 5000);
        return ()=>clearInterval(intervalId);
    }, [
        isAutoRotationEnabled
    ]);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'createWithRovoAnnouncementSplashModal'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleCTAClick = (0, $42omo.useCallback)(()=>{
        openModal('createWithRovoAnnouncementSplashModal', '');
        onModalShown?.('tryRovo');
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'tryCreateWithRovo',
                source: $53648eaef7ca25f4$var$ANALYTICS_SOURCE
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        onModalShown,
        openModal
    ]);
    const handleMenuItemClick = (0, $42omo.useCallback)((index)=>{
        setIsAutoRotationEnabled(false);
        setSelectedGif(index);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createWithRovoAnnouncementSplashModalMenuItem',
                attributes: {
                    menuItem: $53648eaef7ca25f4$var$menuItemLabels[index]
                },
                source: $53648eaef7ca25f4$var$ANALYTICS_SOURCE
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        onModalShown?.('dismissButton');
    }, [
        onModalShown
    ]);
    const handleCarouselControlClick = (0, $42omo.useCallback)(()=>{
        setIsAutoRotationEnabled((prev)=>!prev);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $53648eaef7ca25f4$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8SNb.default), {
        xcss: $53648eaef7ca25f4$var$styles.grid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        grow: "fill",
        space: "space.0",
        xcss: $53648eaef7ca25f4$var$styles.textContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        alignInline: "start",
        space: "space.0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $94a3f55d0cc19894$export$440cce1dd276e44d), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        xcss: $53648eaef7ca25f4$var$styles.titleContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        alignInline: "start",
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        alignInline: "start",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        grow: "fill",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "large"
    }, formatMessage($53648eaef7ca25f4$export$a7357cdd1f0b0168.modalTitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($53648eaef7ca25f4$export$a7357cdd1f0b0168.modalSubtitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)($53648eaef7ca25f4$var$styles.menuItem, selectedGif === 0 && $53648eaef7ca25f4$var$styles.activeMenuItem),
        onClick: ()=>handleMenuItemClick(0)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        direction: "row",
        alignItems: "center",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gNXND))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($53648eaef7ca25f4$export$a7357cdd1f0b0168.modalMenuItemDescribe)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)($53648eaef7ca25f4$var$styles.menuItem, selectedGif === 1 && $53648eaef7ca25f4$var$styles.activeMenuItem),
        onClick: ()=>handleMenuItemClick(1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($53648eaef7ca25f4$export$a7357cdd1f0b0168.modalMenuItemWhiteboard))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)($53648eaef7ca25f4$var$styles.menuItem, selectedGif === 2 && $53648eaef7ca25f4$var$styles.activeMenuItem),
        onClick: ()=>handleMenuItemClick(2)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($53648eaef7ca25f4$export$a7357cdd1f0b0168.modalMenuItemEdit))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        xcss: $53648eaef7ca25f4$var$styles.ctaButtonContainer,
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        onClick: ()=>handleCTAClick(),
        autoFocus: true
    }, formatMessage($53648eaef7ca25f4$export$a7357cdd1f0b0168.modalButtonText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1c0a8b0f35323e7a$export$3f65779459d87753), {
        frame: selectedGif
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $53648eaef7ca25f4$var$styles.closeButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        onClick: ()=>handleDismiss(),
        label: formatMessage($53648eaef7ca25f4$export$a7357cdd1f0b0168.dismissButtonLabel),
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $53648eaef7ca25f4$var$styles.carouselControl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $32f11c1404dd391d$export$f4f648ca4de05347), {
        isPlaying: isAutoRotationEnabled,
        onClick: ()=>handleCarouselControlClick()
    }))));
};








const $9a18421c3f7541fa$export$9af0c5bb35ebf7ef = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isVisible, setIsVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(true);
    const handleVisibilityChange = (0, $42omo.useCallback)((modalOnScreen)=>{
        const shouldShow = !modalOnScreen;
        if (!shouldShow) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'suppressed',
                actionSubject: 'createWithRovoAnnouncementSplashModal',
                source: 'createWithRovoAnnouncementSplashModal'
            }
        }).fire();
        setIsVisible(shouldShow);
    }, [
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        const modalOnScreen = !!globalThis.document.querySelector('.atlaskit-portal-container .atlaskit-portal [role=dialog]');
        handleVisibilityChange(modalOnScreen);
    }, [
        handleVisibilityChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isVisible && children);
};


const $770b5e16d70f1f0d$export$20541310647aec59 = ({ onModalShown: onModalShown = ()=>{} })=>{
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const onModalClose = (0, $42omo.useCallback)(()=>{
        onModalShown('outsideModal');
    }, [
        onModalShown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9a18421c3f7541fa$export$9af0c5bb35ebf7ef), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        messageType: "marketing",
        messageId: "rovo-announcement-splash-modal",
        width: "x-large",
        height: 568,
        onClose: onModalClose,
        shouldCloseOnOverlayClick: true,
        shouldCloseOnEscapePress: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $53648eaef7ca25f4$export$3ceb38454e45a63d), {
        onModalShown: onModalShown
    }))));
};
module.exports["RovoAnnouncementSplashContainer"] = $770b5e16d70f1f0d$export$20541310647aec59;

});

parcelRegister("gNXND", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a463dbdb96f5dd0cff6dca797202b246>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3bf9be9856ff4d9$var$_react = $c3bf9be9856ff4d9$var$_interopRequireDefault((parcelRequire("42omo")));

var $c3bf9be9856ff4d9$var$_baseNew = $c3bf9be9856ff4d9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c3bf9be9856ff4d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Rovo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3bf9be9856ff4d9$var$RovoIcon = (props)=>/*#__PURE__*/ $c3bf9be9856ff4d9$var$_react.default.createElement($c3bf9be9856ff4d9$var$_baseNew.default, Object.assign({
        name: "RovoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.687.64a2.63 2.63 0 0 1 2.625 0l4.404 2.544a2.63 2.63 0 0 1 1.313 2.273v5.084c0 .938-.5 1.804-1.313 2.274l-4.404 2.542a2.63 2.63 0 0 1-2.625 0l-4.403-2.542A2.63 2.63 0 0 1 .97 10.54V5.457c0-.938.5-1.804 1.313-2.273zM3.034 4.483a1.13 1.13 0 0 0-.563.975v5.084c0 .402.215.774.563.975l4.403 2.543c.348.2.777.2 1.125 0l.688-.398v-1.997L5.896 9.568a1.38 1.38 0 0 1-.646-1.166V3.203zM8.562 1.94a1.13 1.13 0 0 0-1.125 0l-.687.398v1.996l3.354 2.097c.402.251.646.692.646 1.166v5.199l2.216-1.28c.348-.2.563-.572.563-.974V5.457c0-.402-.215-.774-.563-.975zM6.75 8.333l2.5 1.563V7.663l-2.5-1.561z" clip-rule="evenodd"/>`
    }, props));
$c3bf9be9856ff4d9$var$RovoIcon.displayName = 'RovoIcon';
var $c3bf9be9856ff4d9$var$_default = module.exports.default = $c3bf9be9856ff4d9$var$RovoIcon;

});

parcelRegister("jyA9t", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $691f60820ad9b181$var$initialState = {
    showSmartCreationModal: false,
    spaceKey: '',
    parentContent: {
        id: '',
        title: '',
        contentType: ''
    },
    content: undefined,
    stagingAreaActive: false,
    entryPoint: 'confluenceUnknown'
};
const $691f60820ad9b181$export$e324594224ef24da = {
    openModal: (entryPoint, spaceKey, parentContent, stagingAreaActive, content)=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: true,
                entryPoint: entryPoint,
                spaceKey: spaceKey,
                parentContent: parentContent ?? {
                    id: '',
                    title: '',
                    contentType: ''
                },
                content: content ?? undefined,
                stagingAreaActive: stagingAreaActive ?? false
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: false,
                content: undefined,
                stagingAreaActive: false,
                entryPoint: 'confluenceUnknown'
            });
        }
};
const $691f60820ad9b181$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $691f60820ad9b181$var$initialState,
    actions: $691f60820ad9b181$export$e324594224ef24da,
    name: 'smartCreationModalStore'
});
const $691f60820ad9b181$export$137abd744dc8b433 = (0, $9zUhf.createHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$809bddce75a17b3 = (0, $9zUhf.createActionsHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$46ab492df7c46301 = (0, $9zUhf.createStateHook)($691f60820ad9b181$export$390f32400eaf98c9);
module.exports["useSmartCreationModalStore"] = $691f60820ad9b181$export$137abd744dc8b433;
module.exports["useSmartCreationModalActions"] = $691f60820ad9b181$export$809bddce75a17b3;
module.exports["useSmartCreationModalState"] = $691f60820ad9b181$export$46ab492df7c46301;

});

parcelRegister("gj7hi", function(module, exports) {
$parcel$export(module.exports, "default", () => $df095e8eefdd8265$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $hWSc7 = parcelRequire("hWSc7");


var $cOrQJ = parcelRequire("cOrQJ");

const $df095e8eefdd8265$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $df095e8eefdd8265$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $42omo.useRef)(null);
    const providedColorMode = (0, $hWSc7.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $cOrQJ.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $42omo.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $gMc0m.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});

parcelRegister("hWSc7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1aJUB = parcelRequire("1aJUB");

function $89c9339d073609a7$export$ce91654eb9fea460() {
    const value = (0, $42omo.useContext)((0, $1aJUB.ColorModeContext));
    return value;
}
module.exports["UNSAFE_useColorModeForMigration"] = $89c9339d073609a7$export$ce91654eb9fea460;

});


//# sourceMappingURL=RovoAnnouncementSplashContainer.d1e1b1c4.js.map
